import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import Navbar from 'react-bootstrap/Navbar'
import { useAuth0 } from '@auth0/auth0-react'
import LoginButton from '../../auth0-config/login'

import AuthorizeButton from '../ModalAuthorize/AuthorizeButton'
import { UserContext } from '../../context/UserContext'
import DropdownUserLogin from './DropdownUserLogin'
import './NavBar.css'

const NavbarLat = () => {
  const { isAuthenticated } = useAuth0()
  const data = useContext(UserContext)
  function toggleMenu() {
    document.getElementById('menu').classList.toggle('active')
  }

  return (
    <>
      <Navbar bg="light" expand="lg" className="sticky-top">
        <div className="navbar-container ">
          <div className="logo-hamburguer" onClick={toggleMenu}>
            &#9776;
          </div>

          {/* TITULO Y LOGO */}
          <NavLink to="/" style={{ textDecoration: 'none' }}>
            <Navbar.Brand className="header-brand" to="/">
              <div className="header-logo-container">
                <img
                  src="https://bimsualize.fra1.digitaloceanspaces.com/logo_bimsualize.png"
                  alt="Branding Logo"
                />
              </div>
              <p className="header-brand__bim">BIM</p>
              <p className="header-brand__visualice">sualize</p>
            </Navbar.Brand>
          </NavLink>
          {/* OPCIONES DEL NAVBAR */}
          <div id="menu" className="nav-links">
            {/* <Nav.Link to="/">Home</Nav.Link> */}
            <NavLink className={'individual-link'} to="/app">
              App
            </NavLink>
            <NavLink className={'individual-link'} to="/precios">
              Precios
            </NavLink>
            <NavLink className={'individual-link'} to="/recursos">
              Recursos
            </NavLink>
            {/* <Button onClick={getAccessToken}>Prueba</Button> */}
            <NavLink
              className={'individual-link'}
              to="/docs/category/primeros-pasos"
              target="_blank"
            >
              Docs
            </NavLink>

            {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
            <NavDropdown.Item to="#action/3.1">Action</NavDropdown.Item>
            <NavDropdown.Item to="#action/3.2">
              Another action //{' '}
            </NavDropdown.Item>
          </NavDropdown> */}
          </div>
          {/* BOTON DE LOGIN/USUARIO Y FOTO DE PERFIL */}
          <div className="login-button">
            {isAuthenticated ? (
              <div
                style={{
                  display: 'flex',
                  gap: '2rem',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <>
                  {data?.user?.autodeskEmail && (
                    <>
                      <AuthorizeButton />
                      <div
                        style={{
                          height: '30px',
                          width: '1px',
                          backgroundColor: '#c6c6c6',
                        }}
                      ></div>
                    </>
                  )}
                  <DropdownUserLogin trialEnd={data.endTrial} />
                </>
              </div>
            ) : (
              <LoginButton />
            )}
          </div>
        </div>
      </Navbar>
    </>
  )
}

export default NavbarLat
